<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/5_Itinerari-esperienze/5c_Natura-benessere_Sila-Gariglione.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Natura e benessere</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Esperienze e itinerari</a> > <a class="active">Natura e benessere</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            La vacanza in Calabria offre molte possibilità agli amanti del benessere. Vi sono diverse stazioni termali dove sgorgano sorgenti d’acque 
            tradizionalmente benefiche per la cura del corpo. Per lo più si tratta di veri e propri parchi termali che offrono trattamenti e attività per un 
            soggiorno rilassante e benefico.
            <br>
            <br>
            Le Terme Sibarite di Cassano allo Jonio utilizzano acque sulfuree note sin dall’antichità mentre quelle di Spezzano, un parco termale di circa dieci ettari, 
            offrono le acque salso-bromo-iodiche della Fonte Thurio. Le Terme di Caronte di Lamezia Terme si possono identificare con le “Aquae Angae” di epoca Imperiale, 
            con vasche naturali in cui l’acqua raggiunge fino a 39°. Le Terme Luigiane di Acquappesa, a due passi dalla costa tirrenica, 
            sono classificate al livello qualitativo 1° Super con acque ipertermali solfuree salsobromojodiche che raggiungono 
            il più alto grado sofidrometrico d’Italia (173 mg/l). 
            <br>
            <br>
            Le proprietà benefiche delle “Acque Sante” della locride, che sgorgano naturalmente a 36°, erano note sin dai tempi di Locri Epizephiri, 
            la città magno-greca che si era dotata di un acquedotto costruito lungo la sponda della fiumara di Gerace. Si tratta di acque termo-minerali, 
            isotoniche, leggermente sulfuree, salso-solfatoalcaline con tracce di jodio.
            <br>
            <br>
            Le Terme di Galatro sorgono nelle vicinanze del paese omonimo, e utilizzano l’acqua sulfureo-salso-iodica delle sorgenti “S. Elia” che sgorgano 
            in una stretta gola del monte Livia alla temperatura naturale di 37°, con principi salutari che furono scoperti dai monaci basiliani giunti sulle 
            ultime pendici terrazzate delle Serre Calabre nell’XI sec.   
            <br>
            <br>
            Altre esperienze di benessere in ambienti naturali sono quelle offerte dai boschi e dalle foreste dei Parchi e delle Riserve calabresi dove 
            si può praticare la silvoterapia. Si pensi che il bosco Archiforo, situato nei pressi di Serra San Bruno, con i suoi abeti maestosi, 
            è stato indicato come uno dei 40 luoghi al mondo più consoni a praticare lo shinrin-yoku, letteralmente “bagno nella foresta” o profonda immersione nella natura, 
            dal medico e immunologo giapponese Quing Li. Non lontano da qui, con affaccio sul Golfo di Squillace, si trova il “Giardino epicureo” di Montauro, 
            il primo giardino sensoriale e terapeutico in Italia ispirato alla filosofia epicurea, che offre esperienze rigeneranti in assoluta armonia con la natura. 
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>